import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const uploadFileCSV = createAction(Constants.TRANSACTION_UPLOAD_FILE_CSV.REQUEST, (file) => (file));
export const clearState = createAction(Constants.TRANSACTION_UPLOAD_FILE_CLEAR_STATE,  () => ({}));

export const uploadFileCSVSuccess = createAction(Constants.TRANSACTION_UPLOAD_FILE_CSV.SUCCESS, (info) => (info));
export const uploadFileCSVRequest = createAction(Constants.TRANSACTION_UPLOAD_FILE_CSV.REQUEST, (info) => (info));
export const uploadFileCSVFailed = createAction(Constants.TRANSACTION_UPLOAD_FILE_CSV.FAILED, (info) => (info));
